module.exports = __webpack_public_path__ + "img/test.71ae7be7.png";